<div class="flex-container button-container">
  <a class="language-buttons"
     [ngClass]="{'selected' : selectedLanguage === 'en'}"
     (click)="onLanguageSelect('en')"
  >EN</a>
  <a class="language-buttons border-left"
     [ngClass]="{'selected' : selectedLanguage === 'fr'}"
     (click)="onLanguageSelect('fr')"
  >FR</a>
  <a class="language-buttons border-left"
     [ngClass]="{'selected' : selectedLanguage === 'de'}"
     (click)="onLanguageSelect('de')"
  >DE</a>
  <a class="language-buttons border-left"
     [ngClass]="{'selected' : selectedLanguage === 'it'}"
     (click)="onLanguageSelect('it')"
  >IT</a>
  <a class="language-buttons border-left"
     [ngClass]="{'selected' : selectedLanguage === 'es'}"
     (click)="onLanguageSelect('es')"
  >ES</a>
</div>
